import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";
import SeoDefault from "./components/SeoDefault";

import Home from "./pages/Home";
import Properties from "./pages/Properties";
import PropertyDetail from "./pages/PropertyDetail";
import Neighborhoods from "./pages/Neighborhoods";
import NeighborhoodDetail from "./pages/NeighborhoodDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import MapSearch from "./pages/MapSearch";
import MlsListings from "./pages/MlsListings";
import MlsListingDetail from "./pages/MlsListingDetail";
import MlsMap from "./pages/MlsMap";
import SavedListings from "./pages/SavedListings";
import SavedSearches from "./pages/SavedSearches";
import HomesForSale from "./pages/HomesForSale";

import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AuthCallback from "./pages/AuthCallback";
import Crm from "./pages/crm/Crm";

import MlsSearchPage from "./pages/har/MlsSearchPage";
import ForeclosuresPage from "./pages/har/ForeclosuresPage";
import HomeValuePage from "./pages/har/HomeValuePage";
import QuickSearchPage from "./pages/har/QuickSearchPage";
import SchoolsPage from "./pages/har/SchoolsPage";
import HarNeighborhoodsPage from "./pages/har/HarNeighborhoodsPage";

import MortgageHome from "./pages/mortgage/MortgageHome";
import LoanPrograms from "./pages/mortgage/LoanPrograms";
import PreApproval from "./pages/mortgage/PreApproval";
import LoanOfficers from "./pages/mortgage/LoanOfficers";
import Refinance from "./pages/mortgage/Refinance";
import DscrCalculator from "./pages/mortgage/DscrCalculator";

import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import TermsOfService from "./pages/legal/TermsOfService";
import FairHousing from "./pages/legal/FairHousing";
import ConsumerProtection from "./pages/legal/ConsumerProtection";
import Iabs from "./pages/legal/Iabs";

import { AuthProvider } from "./lib/auth";
import { FavoritesProvider } from "./lib/favorites";
import ScrollToTop from "./components/ScrollToTop";

function AppShell() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <SeoDefault />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/properties/:id" element={<PropertyDetail />} />
          <Route path="/neighborhoods" element={<Neighborhoods />} />
          <Route path="/neighborhoods/:slug" element={<NeighborhoodDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/map-search" element={<MapSearch />} />
          <Route path="/mls-listings" element={<MlsListings />} />
          <Route path="/mls-listings/:listingKey" element={<MlsListingDetail />} />
          <Route path="/mls-map" element={<MlsMap />} />
          <Route path="/saved-listings" element={<SavedListings />} />
          <Route path="/saved-searches" element={<SavedSearches />} />
          <Route path="/homes-for-sale/:citySlug" element={<HomesForSale />} />

          {/* HAR IDX */}
          <Route path="/mls-search" element={<MlsSearchPage />} />
          <Route path="/foreclosures" element={<ForeclosuresPage />} />
          <Route path="/home-value" element={<HomeValuePage />} />
          <Route path="/quick-search" element={<QuickSearchPage />} />
          <Route path="/schools" element={<SchoolsPage />} />
          <Route path="/har-neighborhoods" element={<HarNeighborhoodsPage />} />

          {/* Mortgage / Edge Home Finance */}
          <Route path="/mortgage" element={<MortgageHome />} />
          <Route path="/loan-programs" element={<LoanPrograms />} />
          <Route path="/pre-approval" element={<PreApproval />} />
          <Route path="/loan-officers" element={<LoanOfficers />} />
          <Route path="/refinance" element={<Refinance />} />
          <Route path="/dscr-calculator" element={<DscrCalculator />} />

          {/* Legal */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/fair-housing" element={<FairHousing />} />
          <Route path="/consumer-protection" element={<ConsumerProtection />} />
          <Route path="/iabs" element={<Iabs />} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/crm" element={<Crm />} />
        </Routes>
      </main>
      <Footer />
      <Chatbot />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <FavoritesProvider>
              <AppShell />
              <Toaster position="top-right" richColors />
            </FavoritesProvider>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
